import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import type { StartLeagueSeason } from "../../../types";
import { queryKeys } from "../../query-keys";

export function useLeagueSeasons(leagueId: string | null) {
	return useQuery({
		enabled: !!leagueId,
		queryFn: () => clubApi.leagues.seasons.list(leagueId as string),
		queryKey: queryKeys.leagues.seasons(leagueId ?? ""),
	});
}

// Closes the open season and opens season N+1 — invalidates the whole
// league (its `current_season`, entries, matches and standings all shift).
export function useStartLeagueSeason() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ leagueId, data }: { leagueId: string; data?: StartLeagueSeason }) =>
			clubApi.leagues.seasons.start(leagueId, data),
		onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.leagues.all }),
	});
}

export function useCloseLeagueSeason() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ leagueId, seasonId }: { leagueId: string; seasonId: string }) =>
			clubApi.leagues.seasons.close(leagueId, seasonId),
		onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.leagues.all }),
	});
}
